var ctaGuideJS = (function () {
  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    var guideBannerCTABtn = document.querySelectorAll('.guide-banner-section__btn-wrapper a'),
      guideFeaturedArticleCSFBtn = document.querySelectorAll('.guide-popup-csf__form--btn'),
      guideFooterBannerCTABtn = document.querySelectorAll('.guide-footer-banner-section-cta__popup-csf-btn');
    
    // For guide page hero banner section CTA event
    if (guideBannerCTABtn.length !== 0) {
      for (var i = 0; i < guideBannerCTABtn.length; i++) {
        guideBannerCTABtn[i].addEventListener(
          "click",
          function () {
            var that = this;
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithArticlePage", bsLib.extend({
              action: (that.text ? that.text : that.textContent) + " Hero Click", 
              "cta-location": "Hero"
            },
            ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {})
            ));
          },
          false
        );
      }
    }

    // For guide page sidebar CTA event
    if (guideFeaturedArticleCSFBtn.length !== 0) {
      for (var i = 0; i < guideFeaturedArticleCSFBtn.length; i++) {
        guideFeaturedArticleCSFBtn[i].addEventListener(
          "click",
          function () {
            var that = this;
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithArticlePage", bsLib.extend({
              action: (that.text ? that.text : that.textContent) + " Sticky Sidebar", 
              "cta-location": "Sticky Sidebar"
            },
            ((popUpCSFOptions.vwoShow) ? {source:'GuidePage_Sidebar'} : {})
            ));
          },
          false
        );
      }
    }

    // For guide page footer banner CTA Btn event
    if (guideFooterBannerCTABtn.length !== 0) {
      for (var i = 0; i < guideFooterBannerCTABtn.length; i++) {
        guideFooterBannerCTABtn[i].addEventListener(
          "click",
          function () {
            var that = this;
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithArticlePage", bsLib.extend({
              action: (that.text ? that.text : that.textContent) + " Bottom CTA Click", 
              "cta-location": "Bottom CTA"
            },
            ((popUpCSFOptions.vwoShow) ? {source:'GuidePage_BottomCTA'} : {})
            ));
          },
          false
        );
      }
    }
  };

  init();
})();